import React, { PureComponent } from 'react'
import packageInfo from "../../../../package.json"

import theme from '../../theme'

// material ui
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Trans } from 'react-i18next'
import { width } from '@mui/system';

var version = packageInfo.version;

const styles = {
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        display: 'flex',
        height: '100%',
    },
    title: {
        padding: '10px 0 18px 0',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
        },
    },
    cardWrapper: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowX:'hidden',
        overflowY:"auto",
        height:'100%',
        marginBottom:20,
        paddingBottom:20,
        //flexWrap: 'wrap',
        //maxWidth: '80%',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
            //marginBottom:20,
            //paddingBottom:20,

        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
            //marginBottom:20,
            //paddingBottom:20,

        }
    },
    card: {
      marginRight: 34,
      height:'100%',
      overflowY:'auto',
      //marginBottom: 10,
      //height: "100%",
      //boxSizing: 'border-box',
      paddingBottom: 10,
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
      },
    },
    cardContent: {
      boxSizing: 'border-box',
      //height:'100%',

      marginBottom:15
    },
    headline: {
        color: '#3C3C3C',
        padding: '20px 10px',
    },
    subheading: {
        color: '#3C3C3C',
        padding: '0 10px 5px 10px',
        fontWeight: "bold"
    },
    text: {
        color: 'rgba(0, 0, 0, 0.87)',
        padding: '0 10px',
        marginBottom: 20,
    },
    cardsTitle: {
        //position: 'absolute',
        marginTop: 20,
        marginBottom: 10,
        padding: '0 10px 10px 0',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '7px',
        },
    },
}


class Information extends PureComponent {
    render () {
        const { classes } = this.props
        return (
            <div style={styles.root}>
                <div style={styles.cardWrapper}>

                <span style={styles.cardsTitle}>
                    <Typography style={styles.title} variant="h5"><Trans>{this.props.title}</Trans></Typography>
                </span>

                <Card style={styles.card}>
                  <CardContent style={styles.cardContent}>
                    <Typography style={styles.headline} variant="h5">
                        <Trans i18nKey="Information.headline"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.legal_info"></Trans>
                    </Typography>
                    <Typography style={styles.subheading}>
                        <Trans i18nKey="Information.ceos_address_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.company_name"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.ceos_address"></Trans>
                    </Typography>
                    <Typography style={styles.subheading}>
                        <Trans i18nKey="Information.ceo_technic_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.ceo_technic"></Trans>
                    </Typography>
                    <Typography style={styles.subheading}>
                        <Trans i18nKey="Information.ceo_sales_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.ceo_sales"></Trans>
                    </Typography>
                    <Typography style={styles.subheading}>
                        <Trans i18nKey="Information.contact_info_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.contact_info"></Trans>
                    </Typography>
                    <Typography style={styles.subheading}>
                        <Trans i18nKey="Information.commercial_register_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.commercial_register"></Trans>
                    </Typography>
                    <Typography style={styles.subheading}>
                        <Trans i18nKey="Information.vat_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <Trans i18nKey="Information.vat"></Trans>
                    </Typography>
                    <Divider />
                    <Typography style={styles.headline} variant="h5">
                        <Trans i18nKey="Information.privacy_heading"></Trans>
                    </Typography>
                    <Typography style={styles.text}>
                        <a  href="https://dezentrale-lueftung.com/datenschutzerklaerung/"
                            target="_blank"
                            rel="noopener noreferrer">
                            https://dezentrale-lueftung.com/datenschutzerklaerung/
                        </a>
                    </Typography>
                    <Divider />
                    <Typography style={styles.headline} variant="h5">
                        Version
                    </Typography>
                    <Typography style={styles.text}>
                        v{version}-{process.env.REACT_APP_GIT_NUM_COMMITS}-{process.env.REACT_APP_GIT_HASH}
                    </Typography>
                  </CardContent>
                </Card>
                </div>
            </div>
        )
    }
}

//Information = withStyles(styles)(Information)

export default Information
